function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import ParagraphWithLogosComponent from "/components/core/paragraph-with-logos/paragraph-with-logos-component";
import { StyledSecurityAndPrivacyComponent } from "./security-and-privacy-component.scss";
const DEFAULT_SECURITY_ASSETS = [
    {
        url: "/static/img/security/gdpr.png",
        alt: "GDPR"
    },
    {
        url: "/static/img/security/iso-27001.png",
        alt: "ISO-27001"
    },
    {
        url: "/static/img/security/iso-27018.png",
        alt: "ISO-27018"
    },
    {
        url: "/static/img/security/soc.png",
        alt: "SOC"
    },
    {
        url: "/static/img/security/hipaa.png",
        alt: "HIPAA"
    }
];
class SecurityAndPrivacyComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledSecurityAndPrivacyComponent, {
            className: "security-and-privacy-component",
            children: /*#__PURE__*/ _jsx("div", {
                className: "paragraph-with-logos-wrapper",
                children: /*#__PURE__*/ _jsx(ParagraphWithLogosComponent, _object_spread({}, this.props))
            })
        });
    }
}
export { SecurityAndPrivacyComponent as default };
SecurityAndPrivacyComponent.defaultProps = {
    assets: DEFAULT_SECURITY_ASSETS,
    paragraph: {
        textDirection: "center",
        title: "We care about your privacy.",
        body: [
            "As users of our own product, we understand how important the security and privacy of your data is. We are committed to providing our customers with a highly secure and reliable environment for its cloud-based application. We have therefore developed a security model that covers all aspects of cloud-based monday.com systems."
        ]
    }
};
